import { Box, Card, Grid, Stack, Typography } from "@mui/material";
import InputControl from "../../../shared/components/InputControl";
import { Loader, LoadingButton } from "../../../shared";
import { useAppPlatformSettings } from "../hooks";
import { TenantInfoText } from "../components";

const platforms = [
  { platform: "android", title: "Android", infoKey: "androidStoreUrl" },
  { platform: "ios", title: "iOS", infoKey: "iosStoreUrl" },
];

const PlatformSettingsForm = ({ platform, title, infoKey }) => {
  const { state, onChange, onSubmit } = useAppPlatformSettings({ platform });

  return (
    <Card component="form" onSubmit={onSubmit} sx={{ p: { xs: 2, sm: 3 } }}>
      {state.isLoading ? (
        <Stack minHeight={130} justifyContent="center" alignItems="center">
          <Loader />
        </Stack>
      ) : (
        <Stack gap={2}>
          <Typography variant="subtitle1" fontWeight={600}>
            {title}
          </Typography>
          <Box>
            <InputControl
              name="store_url"
              label="Store URL"
              value={state.formData.store_url}
              onChange={onChange}
            />
            <TenantInfoText infoKey={infoKey} />
          </Box>

          <LoadingButton
            type="submit"
            variant="contained"
            loading={state.isSubmitting}
            disabled={!state.hasChanges}
            sx={{ minWidth: 80, ml: "auto" }}
          >
            Save
          </LoadingButton>
        </Stack>
      )}
    </Card>
  );
};

export const AppPlatformSettingsConfig = () => (
  <Grid container spacing={2} alignItems="stretch">
    {platforms.map(({ platform, title, infoKey }) => (
      <Grid item key={platform} sm={12}>
        <PlatformSettingsForm
          platform={platform}
          title={title}
          infoKey={infoKey}
        />
      </Grid>
    ))}
  </Grid>
);
